import { IControllbarTooltipProps } from "interfaces";

const ControllbarTooltip = ({ title, className }: IControllbarTooltipProps) => (
    <span
        className={`pl-absolute pl-w-max pl-bg-secondary-900/[0.8] pl-text-white pl-bottom-[230%] pl-right-[-18px] pl-rounded-[8px] pl-px-2 pl-py-[5px] pl-text-[14px] pl-font-bold ${className}`}
    >
        {title}
    </span>
);

export default ControllbarTooltip;
